import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import s from './Flex.scss';
var Flex = /** @class */ (function (_super) {
    tslib_1.__extends(Flex, _super);
    function Flex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Flex.prototype.render = function () {
        var props = this.props;
        var classNames = classnames(s['flex'], props.inline && s['inline'], props.justifyContent && s["justify-content-" + props.justifyContent], props.alignItems && s["align-items-" + props.alignItems], props.direction && s["direction-" + props.direction], props.wrap && s["wrap-" + props.wrap], props.fullWidth && s['full-width'], props.fullHeight && s['full-height'], props.className);
        return (React.createElement("div", { className: classNames, style: props.style, "data-hook": props.dataHook, onClick: props.onClick }, this.props.children));
    };
    return Flex;
}(React.Component));
export default Flex;
//# sourceMappingURL=Flex.js.map